export const useFetchChart = async () => {

  const route = useRoute()
  const { locale } = useI18n()

  async function fetchChart(chartLabel: string) {
    return await useAsyncData(
      `chart-${route.path}-${locale.value}-${chartLabel}`,
      async () => {
        const response = await $fetch('/api/v1/contentful/investor/chart', {
          query: {
            locale: locale.value,
            path: route.path,
            chartLabel,
          },
        })

        const chart = response.chart ?? null
        return chart
      })

  }

  async function fetchCharts(chartLabels: string[]) {
    const normalizedLabels = chartLabels
      .map(label => label.trim())
      .filter(Boolean)

    return await useAsyncData(
      `charts-${route.path}-${locale.value}-${normalizedLabels.join('|')}`,
      async () => {
        if (!normalizedLabels.length) {
          return []
        }

        const response = await $fetch('/api/v1/contentful/investor/chart', {
          query: {
            locale: locale.value,
            path: route.path,
            chartLabels: normalizedLabels.join(','),
          },
        })

        return response.charts ?? []
      },
    )
  }

  return {
    fetchChart,
    fetchCharts,
  }
}
